export function setIngresos(state, ingresos) {
    state.ingresos = ingresos;
}
